import React from 'react';
import { Label } from '@/components/atoms/texts/label';
import { useTranslation } from 'react-i18next';

const HistoryBubble = ({ event, locale }) => {
    const [t] = useTranslation('global');
    const eventDate = new Date(event.timestamp);
    const today = new Date();

    const isSameDayAsToday = eventDate.getFullYear() === today.getFullYear()
        && eventDate.getMonth() === today.getMonth()
        && eventDate.getDate() === today.getDate();

    const timeLabel = `${eventDate.getHours()}h${String(eventDate.getMinutes()).padStart(2, '0')}`;
    const dateLabel = eventDate.toLocaleDateString(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });

    const eventCodeKey = `management.onboarding.chat.event_codes.${String(event.eventCode || '').toLowerCase()}`;
    const timeConnector = t('management.onboarding.chat.history.connectors.time');
    const dateConnector = t('management.onboarding.chat.history.connectors.date');
    const eventDateTimeLabel = isSameDayAsToday
        ? `${timeConnector} ${timeLabel}`
        : `${dateConnector} ${dateLabel} ${timeConnector} ${timeLabel}`;
    const eventTitleWithDate = `${t(eventCodeKey)} ${eventDateTimeLabel}`;

    return (
        <div className="flex items-start gap-2.5 my-1.5">
            <div className="flex flex-col w-full grow items-center justify-center">
                <div className="rounded-lg w-full bg-information20 border border-information px-3 py-2">
                    <div className="flex flex-col gap-1 leading-none">
                        <Label size="small" color="primary" fontWeight="semibold">{eventTitleWithDate}</Label>
                        {event.eventMessage && event.eventMessage.length > 0 && (
                            <Label size="caption">
                                {event.eventMessage}
                            </Label>
                        )}
                    </div>
                    {event.additionalInfo && event.additionalInfo.length > 0 && (
                        <div className="mt-2 pt-2 border-t border-primary/10">
                            <Label
                                color="primary"
                                size="caption"
                            >
                                {event.additionalInfo}
                            </Label>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HistoryBubble;
